import React, { useEffect, useState } from "react";
//import { GetWebData, updateWebData } from "../../api/Webdesign.Api";
import { RootState } from "../../../redux/Store";
import { useSelector } from "react-redux";
import { WebDataItem } from "../../models/WebData";
import DataTable, { TableColumn } from "react-data-table-component";
import DataTableFilter from "../../components/DataTableFilter";
import { NewDeal } from "../../models/NewDeal";
import { GetAllCustomers } from "../../api/Customer.Api";
import {
  Checkbox,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { Customer } from "../../../interfaces/models/Customer";
import { ProductsData } from "../../models/Products";
import { GetAllProducts } from "../../api/Products.Api";
import { GetAllCampains, SaveEmailCampaign } from "../../api/Campain.Api";
import moment from "moment";
import { CampaignDetails, NewDealReqest } from "../../models/NewDealReqest";

const NewDeals: React.FC = () => {
  const loggedInUser = useSelector((state: RootState) => state.user);
  const [pending, setPending] = React.useState(true);
  const [campainName, setCampainName] = useState("");
  const [campainList, setCampainList] = useState<NewDeal[]>([
    {
      name: "",
      emails: "",
      productTitles: "",
      created_at: "",
    },
  ]);

  const [productList, setProductsList] = useState<ProductsData[]>([
    {
      id: 0,
      title: "",
      subTitle: "",
      categoryId: "",
      descriptionShort: "",
      descriptionLong: "",
      additionalInfo: "",
      terms: "",
      location: "",
      amount: "",
      icon: "",
      active: true,
    },
  ]);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  useEffect(() => {
    loadCustomerList();
    handleProductList();
    fetchCampainData();
  }, []);

  const fetchCampainData = async () => {
    const campainData = await GetAllCampains(loggedInUser.token);
    setCampainList(campainData);
    setPending(false);
  };

  const columns: TableColumn<NewDeal>[] = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "productTitles",
      selector: (row) => row.productTitles,
      sortable: true,
      wrap: true, // enables internal wrapping
      grow: 2,
    },
    {
      name: "Users Email",
      selector: (row) => row.emails,
      sortable: true,
      grow: 2,
      wrap: true, // enables internal wrapping
    },
    {
      name: "Date Sent",
      selector: (row) => moment(row.created_at).format("DD MMM YYYY, HH:mm:ss"),
      sortable: true,
    },
  ];

  const filteredItems = campainList.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [customerList, setCustomerList] = useState<Customer[]>([]);

  const [selectedCustomerIds, setSelectedCustomerIds] = useState<number[]>([]);

  const handleChangeCustomer = (event: any) => {
    setSelectedCustomerIds(event.target.value);
  };

  const loadCustomerList = async () => {
    var c = await GetAllCustomers(loggedInUser.token, 0, "", "", 0, 0);
    setCustomerList(c.data);
  };

  const handleProductList = async () => {
    const productsList = await GetAllProducts(loggedInUser.token);
    setProductsList(productsList);
    setPending(false);
  };

  const [selectedInvestmentIds, setSelectedInvestmentIds] = useState<number[]>(
    []
  );

  const handleChangeInvestment = (event: any) => {
    setSelectedInvestmentIds(event.target.value);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <div>
        <DataTableFilter
          onFilter={(e: any) => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
          handleCreateNew=""
          addButtonName=""
          isShow="false"
        />
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  // Function to save data via API call
  const handleSaveData = async () => {
    try {
      const data: NewDealReqest = {
        campaignDetails: new CampaignDetails(campainName),
        customerIds: selectedCustomerIds,
        productIds: selectedInvestmentIds,
      };
      SaveEmailCampaign(loggedInUser.token, data);
      setSelectedCustomerIds([]);
      setSelectedInvestmentIds([]);
      setCampainName("");
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        boxSizing: "border-box",
      }}
    >
      {/* Form Header */}
      <h2 style={{ textAlign: "left", marginBottom: "20px" }}>
        New Deals - Newsletter Platform
      </h2>

      {/* Add new newsletter */}
      <div
        style={{
          alignItems: "center",
          marginTop: "40px",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <div>
          <Grid container spacing={3}>
            <Grid item sm={12} md={12}>
              <FormLabel style={{ paddingRight: "44px", paddingTop: "12px" }}>
                Campain Name:{" "}
              </FormLabel>
              <TextField
                id="campainName"
                variant="outlined"
                value={campainName}
                onChange={(e) => setCampainName(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} md={12}>
              <FormLabel style={{ paddingRight: "40px" }}>
                Customers (IDs):{" "}
              </FormLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedCustomerIds}
                onChange={handleChangeCustomer}
                style={{ width: "500px" }}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {customerList.map((customer) => (
                  <MenuItem key={customer.id} value={customer.id}>
                    <Checkbox
                      checked={selectedCustomerIds.includes(customer.id)}
                    />
                    <ListItemText primary={customer.name} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item sm={12} md={12}>
              <FormLabel style={{ paddingRight: "20px" }}>
                Investoments (IDs):{" "}
              </FormLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedInvestmentIds}
                onChange={handleChangeInvestment}
                style={{ width: "500px" }}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {productList.map((investment) => (
                  <MenuItem key={investment.id} value={investment.id}>
                    <Checkbox
                      checked={selectedInvestmentIds.includes(investment.id)}
                    />
                    <ListItemText primary={investment.title} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </div>
        {/* Save Button Container */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end", // Align to right
            alignItems: "center",
            marginTop: "40px",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <p style={{ marginRight: "20px", marginTop: "10px" }}>
            By clicking send it will send automated templated email to the
            selected customers, This action can not be undo!
          </p>
          <button
            style={{
              padding: "12px 60px",
              fontSize: "16px",
              fontWeight: "bold",
              color: "#fff",
              backgroundColor: "#007bff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "background-color 0.3s",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#0056b3")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#007bff")
            }
            onClick={handleSaveData}
          >
            send
          </button>
        </div>
      </div>

      {/* Add new newsletter */}
      <div
        style={{
          alignItems: "center",
          marginTop: "40px",
          padding: "2px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <div style={{ padding: "0", width: "100%" }}>
          <DataTable
            title="Newsletter history"
            columns={columns}
            data={filteredItems}
            pagination
            paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            persistTableHead
            progressPending={pending}
          />
        </div>
      </div>
    </div>
  );
};

export default NewDeals;
